import React, { useState } from 'react';
import axios from 'axios';
import { Mail, Heart, Sparkles, Rss } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/signup`, { email, name: name || undefined });
      toast.success('Successfully subscribed to newsletter!');
      setEmail('');
      setName('');
    } catch (error) {
      if (error.response?.data?.message === 'Already subscribed') {
        toast.info('You\'re already subscribed!');
      } else {
        toast.error('Failed to subscribe. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#2D2A26] text-white border-t-2 border-black mt-20">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Sparkles className="w-6 h-6 text-[#FF6B6B]" strokeWidth={2.5} />
              <h3 className="text-3xl font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
                Daily Wit
              </h3>
            </div>
            <p className="text-gray-300 mb-6">
              World news with a twist of humor. Stay informed, stay entertained.
            </p>
            <p className="text-sm text-gray-400">
              Made with <Heart className="w-4 h-4 inline text-[#FF6B6B]" strokeWidth={2.5} /> for busy people who love to laugh
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
              Never Miss the Wit
            </h3>
            <p className="text-gray-300 mb-4">
              Get daily humorous news at 7am EST delivered to your inbox
            </p>
            <form onSubmit={handleSubscribe} className="space-y-3">
              <div className="flex gap-3">
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name (optional)"
                  data-testid="newsletter-name-input"
                  className="w-1/3 border-2 border-black rounded-lg p-3 text-black focus:ring-2 focus:ring-[#FF6B6B] focus:outline-none shadow-[4px_4px_0px_0px_rgba(0,0,0,0.3)]"
                />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  data-testid="newsletter-email-input"
                  required
                  className="flex-1 border-2 border-black rounded-lg p-3 text-black focus:ring-2 focus:ring-[#FF6B6B] focus:outline-none shadow-[4px_4px_0px_0px_rgba(0,0,0,0.3)]"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-subscribe-button"
                className="w-full bg-[#FF6B6B] text-white font-bold px-6 py-3 rounded-lg border-2 border-black hover:bg-[#FF5252] transition-all hard-shadow-hover flex items-center justify-center gap-2 disabled:opacity-50"
              >
                <Mail className="w-5 h-5" strokeWidth={2.5} />
                Subscribe to Daily Newsletter
              </button>
            </form>
          </div>
        </div>

        <div className="border-t-2 border-gray-700 mt-8 pt-6 text-center text-sm text-gray-400">
          <div className="flex items-center justify-center gap-4 mb-4 flex-wrap">
            <a href="/my-story" className="hover:text-[#FF6B6B] transition-colors">My Story</a>
            <span>|</span>
            <a href="/trending" className="hover:text-[#FF6B6B] transition-colors">Trending</a>
            <span>|</span>
            <a 
              href={`${BACKEND_URL}/api/rss`} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-[#FF6B6B] transition-colors flex items-center gap-1"
              data-testid="rss-feed-link"
            >
              <Rss className="w-4 h-4" />
              RSS Feed
            </a>
            <span>|</span>
            <a href="https://twitter.com/dailywit_news" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF6B6B] transition-colors">Twitter</a>
            <span>|</span>
            <a href="https://instagram.com/dailywit.news" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF6B6B] transition-colors">Instagram</a>
          </div>
          <p>&copy; 2026 Daily Wit. All rights reserved. | Making news fun, one article at a time.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;